import { DisplayPosition } from '@/type/display-position';
import CnAddressM from '@cainiaofe/cn-address-m';
import isPlainObject from 'lodash/isPlainObject';
import { isEmptyButNotZero } from '@/common/util/util';
import set from 'lodash/set';
import { countryList } from '@/common/util/country-datasource';
export default {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
    ],
    title: '地址选择器',
    componentName: 'CnAddressM',
    formComponent: CnAddressM,
    getFormItemDefaultProps: () => {
        return {
            placeholder: '请选择',
        };
    },
    getDefaultProps: () => {
        return {
            // multiple: false,
            showTopLevel: false,
            maxLevel: 4,
            // showSearch: true,
        };
    },
    formItemBeforeHandler: (formItem, config) => {
        if (formItem) {
            const componentProps = formItem['x-component-props'];
            if (isPlainObject(componentProps)) {
                const { showTopLevel } = componentProps || {};
                if (showTopLevel === undefined || showTopLevel === true) {
                    // newProps.maxLevel = 5
                    componentProps.iso = '';
                }
                else if (Array.isArray(showTopLevel) && showTopLevel.length > 0) {
                    componentProps.iso = '';
                    componentProps.includeList = showTopLevel;
                }
                delete componentProps.showTopLevel;
                if (!componentProps.config) {
                    componentProps.config = {
                        apiModel: 'mtop',
                        businessId: 'toffee',
                    };
                }
                const { extra = {} } = componentProps;
                if (isPlainObject(extra)) {
                    for (const key in extra) {
                        const temV = extra[key];
                        if (key && !isEmptyButNotZero(temV)) {
                            if (key === 'needSkipLevelData' ||
                                key === 'showDisabledDivision') {
                                set(componentProps, `${key}`, temV);
                            }
                            else {
                                set(componentProps, `config.${key}`, temV);
                            }
                        }
                    }
                }
                delete componentProps.extra;
            }
        }
    },
    getPrototypeList: () => {
        return [
            // {
            //   name: 'multiple',
            //   title: '选择模式',
            //   display: 'inline',
            //   // supportVariable: true,
            //   condition(prop) {
            //     return condition(prop, 'CnAddressM', 'componentName');
            //   },
            //   setter: {
            //     componentName: 'RadioGroupSetter',
            //     props: {
            //       options: [
            //         {
            //           title: '单选',
            //           value: false,
            //         },
            //         {
            //           title: '多选',
            //           value: true,
            //         },
            //       ],
            //     },
            //   },
            // },
            {
                name: 'showTopLevel',
                title: '选择国家',
                display: 'inline',
                setter: {
                    componentName: 'MixedSetter',
                    props: {
                        setters: [
                            {
                                componentName: 'RadioGroupSetter',
                                title: '是 或 否',
                                props: {
                                    options: [
                                        {
                                            title: '全部国家',
                                            value: true,
                                        },
                                        {
                                            title: '不支持',
                                            value: false,
                                        },
                                    ],
                                },
                            },
                            {
                                componentName: 'CnSelectSetter',
                                title: '选择部分国家',
                                props: {
                                    options: countryList,
                                    selectProps: {
                                        mode: 'multiple',
                                        showSearch: true,
                                    },
                                },
                            },
                        ],
                    },
                },
            },
            {
                name: 'maxLevel',
                title: '最多展示几级',
                display: 'inline',
                setter: {
                    componentName: 'NumberSetter',
                    props: {
                        hasClear: true,
                    },
                },
            },
            // {
            //   name: 'useDetailValue',
            //   title: '使用详细数据 ',
            //   display: 'inline',
            //   setter: {
            //     componentName: 'RadioGroupSetter',
            //     props: {
            //       options: [
            //         { title: '是', value: true },
            //         { title: '否', value: false },
            //         { title: '不设置' },
            //       ],
            //     },
            //   },
            // },
            // {
            //   name: 'showSearch',
            //   title: '支持选择',
            //   condition(prop) {
            //     return false;
            //   },
            //   setter: 'BoolSetter',
            // },
            // {
            //   name: 'changeOnSelect',
            //   title: '支持选中非最后一级',
            //   setter: {
            //     componentName: 'RadioGroupSetter',
            //     props: {
            //       options: [
            //         { title: '是', value: true },
            //         { title: '否', value: false },
            //         { title: '不设置' },
            //       ],
            //     },
            //   },
            // },
            // {
            //   title: '高级配置',
            //   name: 'extra',
            //   display: 'accordion',
            //   extraProps: {
            //     defaultCollapsed: true,
            //   },
            //   setter: {
            //     componentName: 'ObjectSetter',
            //     props: {
            //       config: {
            //         items: [
            // {
            //   name:'realm',
            //   title:'数据版本',
            //   setter:'StringSetter'
            // },
            // {
            //   display: 'none',
            //   setter:<DocSetter
            //     content={<a target={'_blank'} >
            //       正常您不需要配置该属性，当您对数据有定制要求时请联系星马
            //     </a>}
            //   />
            // },
            // {
            //   name:'needSkipLevelData',
            //   title:'是否需要跳级数据',
            //   display: 'inline',
            //   setter: {
            //     componentName: 'RadioGroupSetter',
            //     props: {
            //       options: [
            //         { title: '是', value: true },
            //         { title: '否', value: false },
            //         { title: '不设置' },
            //       ],
            //     },
            //   },
            // },
            // {
            //   name:'showDisabledDivision',
            //   title:'地址数据库中,是否展示已删除数据',
            //   setter:'StringSetter',
            //   display: 'inline',
            //   setter: {
            //     componentName: 'RadioGroupSetter',
            //     props: {
            //       options: [
            //         { title: '是', value: true },
            //         { title: '否', value: false },
            //         { title: '不设置' },
            //       ],
            //     },
            //   },
            // },
            // {
            //   name: 'isSearchById',
            //   title: '开启ID搜索',
            //   setter: 'BoolSetter',
            // },
            //       ]
            //     }
            //   }
            // }
            // },
        ];
    },
};
